import * as types from "../actions/ActionTypes";

const initialState = {
  loading: false,
  configsByCategory: {},
  validation_error: null,
};

const SetupConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SETUP_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        validation_error: null,
      };

    case types.SETUP_CONFIG_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        configsByCategory: {
          ...state.configsByCategory,
          [action.category]: action.items || [],
        },
      };

    case types.SETUP_CONFIG_SAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        configsByCategory: {
          ...state.configsByCategory,
          [action.category]: action.items || [],
        },
      };

    case types.SETUP_CONFIG_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
        validation_error: action.validation_error,
      };

    case types.HIDE_SETUP_CONFIG_FIELD_VALIDATION_ERROR: {
      if (!state.validation_error?.[action.field_key]) {
        return state;
      }

      const nextValidationError = { ...state.validation_error };
      delete nextValidationError[action.field_key];
      return {
        ...state,
        validation_error: nextValidationError,
      };
    }

    default:
      return state;
  }
};

export default SetupConfigurationReducer;
